import { Link } from '@mui/material';
import { Fragment } from 'react';
import { addressText, BUSINESS, phoneText } from '@core/business.ts';
import { getSite } from '@/lib/site';

/** The support phone numbers as tap-to-call links, written the way this site's visitors dial them ("022 …" in New Zealand, "+64 22 …" from Australia). */
export function PhoneLinks({ separator = ' or ' }: { separator?: string }) {
  const site = getSite();
  return (
    <>
      {BUSINESS.phones.map((p, i) => (
        <Fragment key={p.e164}>
          {i > 0 && separator}
          <Link href={`tel:${p.e164}`} sx={{ fontWeight: 600, whiteSpace: 'nowrap' }}>
            {phoneText(p, site)}
          </Link>
        </Fragment>
      ))}
    </>
  );
}

/** "Built by Digitalforge", linking to their website. */
export function BuiltBy() {
  return (
    <>
      Built by{' '}
      <Link href={BUSINESS.builtBy.url} target="_blank" rel="noopener" sx={{ fontWeight: 600 }}>
        {BUSINESS.builtBy.name}
      </Link>
    </>
  );
}


/** "25 Medway St, Richmond, Christchurch". */
export const BusinessAddress = () => <>{addressText()}</>;

/** "Monday to Friday, 9am to 5pm New Zealand time (excluding public holidays)". */
export const SupportHours = () => <>{BUSINESS.hours.text}</>;
